<template>
    <div class="d-flex align-items-center ma-2">
        <DialogoCard ref="refDialogo" :titulo="titulo" :tipo="tipo" :width="ancho" />
        <DialogoFotos ref="dialFotos" :titulo="titulo" :tipo="tipo" :width="ancho" />
        <div v-if="$vuetify.breakpoint.smAndUp" class="mr-2 text-right">
            <div class="font-weight-bold">{{ user.nombres }} {{ user.apellido }}</div>
            <v-row>
                <v-col v-if="emailAuth" class="text-subtitle-2">
                    <div class="d-inline font-weight-bold">Nº {{ pronombre }}: {{ nroafi }} </div> | {{
                        emailAfiliado
                    }}
                </v-col>
            </v-row>
        </div>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <!-- El v-badge ENVUELVE al avatar, asi que no lleva v-if: se
                         llevaria puesta la foto de perfil. Se apaga con :value,
                         que oculta solo el globito y deja intacto el contenido. -->
                    <v-badge color="red" overlap :content="cantidadAvisosNoLeidos"
                        :value="avisosHabilitados && cantidadAvisosNoLeidos > 0">
                        <v-avatar size="45" color="white">
                            <v-img v-if="user.fotoperfil" :src="`data:image/jpeg;base64,${user.fotoperfil}`" />
                            <v-img v-else src="@/assets/img-user-profile.png" contain />
                        </v-avatar>
                    </v-badge>
                </v-btn>
            </template>
            <v-card width="250" class=" text-center rounded-0">
                <!-- El guard va aca, en el punto de montaje, y no adentro de
                     menuNotify: si el padre no lo monta, nada de lo que tiene
                     adentro importa. El hijo no necesita conocer el flag. -->
                <menuNotify v-if="avisosHabilitados" />
                <v-divider></v-divider>
                <v-col cols="12" md="12">
                    <a @click="lanzarDialogFoto">
                        <!--                         <v-btn absolute style="position:absolute;bottom:0px;left: 55%; top: 139px;" fab small
                            color="primary">
                            <v-icon>mdi-camera-plus-outline</v-icon>
                        </v-btn> -->
                        <v-btn absolute fab small color="primary" :style="estiloBotonCamara">
                            <v-icon>mdi-camera-plus-outline</v-icon>
                        </v-btn>
                        <v-avatar size="110" v-if="user.fotoperfil">
                            <v-img :src="`data:image/png;base64,${user.fotoperfil}`" />
                        </v-avatar>
                        <v-avatar size="110" v-else>
                            <v-img src="@/assets/img-user-profile.png" contain />
                        </v-avatar>
                    </a>
                </v-col>
                <div>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold black--text">{{ user.nombres
                                }} {{ user.apellido }} </v-list-item-title>
                            <v-list-item-title class="font-weight-bold"></v-list-item-title>
                            <v-list-item-title class="font-weight-bold primary--text text-body-1">Matrícula Nº {{
                                user.nroafi
                                }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>
                <div>
                    <v-divider></v-divider>
                    <v-btn class=" pa-6 rounded-0" block text @click="lanzarCambiarPass">
                        <v-icon class="mr-2">mdi-account-key-outline</v-icon>
                        cambiar contraseña
                    </v-btn>
                    <v-divider></v-divider>
                    <v-btn class="pa-6 rounded-0" text block @click="closeSesion">
                        <v-icon class="mr-2">mdi-logout</v-icon>
                        cerrar sesión
                    </v-btn>
                </div>
            </v-card>
        </v-menu>
    </div>
</template>
<script>
import DialogoCard from '@/components/dialogos/DialogoCard.vue'
import DialogoFotos from '@/components/dialogos/DialogoFotos.vue';
import menuNotify from '@/components/navigations/menuNotify.vue';
import ProfileAvatar from '@/assets/icons/profile-avatar.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        DialogoCard,
        DialogoFotos,
        menuNotify,
        ProfileAvatar
    },
    data() {
        return {
            loadImg: false,
            titulo: '',
            contador: 0,
            ancho: '',
            tipo: '',
            items: [
                { title: 'CAMBIAR CONTRASEÑA', icon: 'mdi-account-key-outline' },
                { title: 'CERRAR SESION', icon: 'mdi-logout' },
            ],

            width: '',

        }
    },
    computed: {
        ...mapGetters('auth', ['user', 'emailAuth', 'loadSkeleton', 'isAuthenticated', 'nroafi', 'email']),
        ...mapGetters(['emailPrinc']),
        ...mapGetters('avisos', ['cantidadAvisosNoLeidos', 'avisosHabilitados']),

        pronombre() {
            switch (this.user.sexo) {
                case "M":
                    return "Afiliado"
                case "F":
                    return "Afiliada"
                default:
                    return "Afiliadx"
            }
        },
        emailAfiliado() {
            // Prioridad: emailPrinc > user.email > emailAuth
            if (this.emailPrinc && this.emailPrinc.email) {
                return this.emailPrinc.email;
            } else if (this.user && this.user.email) {
                return this.user.email;
            } else if (this.emailAuth) {
                return this.emailAuth;
            }
            return '';
        },
        estiloBotonCamara() {
            return {
                bottom: '0px',
                left: '55%',
                // Sin el item de notificaciones, el card arranca mas arriba y el
                // boton tiene que subir lo mismo que mide ese item.
                top: this.avisosHabilitados ? '139px' : '85px',
            }
        },
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion']),
        ...mapActions('notificaciones', ['startLoading']),
        ...mapActions('avisos', ['obtenerAvisos']),

        lanzarDialogFoto() {
            this.titulo = 'Foto de perfil'
            this.tipo = "fotoperfil"
            this.ancho = 500
            this.$refs.dialFotos.abrirDialogo()
        },

        lanzarCambiarPass() {
            this.titulo = 'Cambio de contraseña'
            this.ancho = 700
            this.tipo = 'pass'
            this.$refs.refDialogo.abrirDialogo()
        },

        closeSesion() {
            this.startLoading()
            this.cerrarSesion()
            //this.$router.push('/CerrarSesion').catch(() => { })
        }
    },
    mounted() {
        // Cargar email si no está disponible
        if (!this.emailAfiliado && this.isAuthenticated) {
            this.$store.dispatch('getEmail');
        }
        // El badge del avatar se ve en todo el portal, no solo en /notificaciones,
        // asi que pedimos los avisos al montar la barra de usuario.
        // Con el feature apagado no se pide nada: no tiene sentido pegarle a la
        // API en cada carga del portal para alimentar algo que no se muestra.
        if (this.isAuthenticated && this.avisosHabilitados) {
            this.obtenerAvisos();
        }
    }
}
</script>

<style>
.algo {
    position: relative;
    top: 0;
}
</style>